<div class="flex column gap-16 align-items-center">
  <app-step-indicator
    [currentStep]="currentIndex()"
    [maxSteps]="stepOrder.length"
  />

  @switch (onboardingStep()) {
    @case (NewWalletStep.CREATE_PASSWORD) {
      <div [@stepAnimation]="slideDirection()">
        <app-create-password-new-wallet-step
          (next)="next()"
          (previous)="previous()"
        />
      </div>
    }
    @case (NewWalletStep.CREATE_SEED_PHRASE) {
      <div [@stepAnimation]="slideDirection()">
        <app-create-seed-phrase-new-wallet-step
          (next)="next()"
          (previous)="previous()"
          [hideBackButton]="skipPassword()"
        />
      </div>
    }
    @case (NewWalletStep.SET_SEED_PASSPHRASE) {
      <div [@stepAnimation]="slideDirection()">
        <app-set-seed-passphrase-new-wallet-step
          (next)="next()"
          (previous)="previous()"
        />
      </div>
    }
    @case (NewWalletStep.VERIFY_SEED_PHRASE) {
      <div [@stepAnimation]="slideDirection()">
        <app-verify-seed-phrase-new-wallet-step
          (next)="next()"
          (previous)="previous()"
        />
      </div>
    }
    @case (NewWalletStep.ADDRESS) {
      <div [@stepAnimation]="slideDirection()">
        <app-address-new-wallet-step (next)="next()" (previous)="previous()" />
      </div>
    }
    @case (NewWalletStep.SUCCESS) {
      <div @stepAnimation>
        <app-success-new-wallet-step
          @stepAnimation
          (next)="next()"
          (previous)="previous()"
        />
      </div>
    }
    @case (NewWalletStep.ERROR) {
      <div @stepAnimation>
        <app-error-new-wallet-step
          @stepAnimation
          (next)="next()"
          (previous)="previous()"
        />
      </div>
    }
  }
</div>
